import { Draft, PayloadAction } from '@reduxjs/toolkit';
import formatters from 'formatters';

import IGetAllThreadsInterventionResponse from 'services/httpClient/responses/intervention/IGetAllThreadsInterventionResponse';

import { IInterventionData } from '../../initialState';

export interface IGetAllThreadsSuccessWithDataAction {
  list: IGetAllThreadsInterventionResponse[];
}

function getAllThreadsSuccessWithData(
  draft: Draft<IInterventionData>,
  action: PayloadAction<IGetAllThreadsSuccessWithDataAction>,
) {
  draft.getAllThreads.list = action.payload.list.map(thread => ({
    archived: thread.archived,
    messages: thread.messages.map(message => ({
      text: message.text,
      companyname: message.companyname,
      wroteBy: message.wrote_by,
      createdAt: formatters.date(message.created_at, { formatType: 'DD/MM' }),
      name: message.name,
      id: message.id,
      open: message.open,
      subject: thread.subject,
    })),
    subject: thread.subject,
    threadMessageId: thread.thread_message_id,
    unreadTrader: thread.unread_trader,
    unreadOps: thread.unread_ops,
    traderId: thread.trader_id,
    interventionId: thread.intervention_id,
  }));
  draft.getAllThreads.config.isLoading = false;
}

export default getAllThreadsSuccessWithData;
